(function ( $ ) {
    $.fn.addressSelector = function(val, params) {
        $(this).each(function() {
            const elm = $(this);

            if (params === undefined) {
                params = {
                    filters: {},
                }
            }
            params['type'] = 'address';

            const contactSelector = elm.parents('form').find('[data-contact-selector]');
            if (contactSelector.length > 0) {
                contactSelector.change(function() {
                    elm.removeClass('has-special-selector');
                    let val = parseInt($(this).val());


                    if (val > 0) {
                        params['filters']['contact_id'] = val;
                    } else if(params['filters']['contact_id']) {
                        const newObj = {};
                        Object.keys(params.filters).forEach(function(key) {
                            if (key !== 'contact_id') {
                                newObj[key] = params[key];
                            }
                        });
                        params.filters = newObj;
                    }

                    elm.addressSelector(val, params);
                });
            }
            const companySelector = elm.parents('form').find('[data-company-selector]');
            if (companySelector.length > 0) {
                companySelector.change(function() {
                    elm.removeClass('has-special-selector');
                    let val = parseInt($(this).val());

                    if (val > 0) {
                        params['filters']['company_id'] = val;
                    } else if(params['filters']['company_id']) {
                        const newObj = {};
                        Object.keys(params.filters).forEach(function(key) {
                            if (key !== 'company_id') {
                                newObj[key] = params[key];
                            }
                        });
                        params.filters = newObj;
                    }

                    elm.addressSelector(val, params);
                });
            }


            if (params.filters['contact_id'] === undefined && params.filters['company_id'] === undefined) {
                elm.attr('disabled', 'disabled');
                const prev = elm.prev();

                if (prev.hasClass('special-selector-search-bar')) {
                    prev.attr('disabled', 'disabled');
                }
            } else {
                elm.removeAttr('disabled');
                const prev = elm.prev();

                if (prev.hasClass('special-selector-search-bar')) {
                    prev.removeAttr('disabled');
                }
            }

            elm.change(function() {
                choose_this_address(this);
            });

            elm.specialSelector({
                url: '/ajax/specialSelectorSearch',
                params: params,
                type: 'address',
                val: val,
                noPromises: true,
                placedOptions: (elm) => {
                    elm.val(elm.find(':nth-child(2)').attr('value') || -1)
                },
                option: function(row) {
                    const nameStr = row.name;

                    const newObj = {};
                    Object.keys(row).forEach(function(key) {
                        if (key !== 'name') {
                            newObj[key] = row[key];
                        }
                    });

                    return '<option value=\'' + JSON.stringify(newObj) + '\'>'+nameStr+'</option>';
                }
            });
        });
        return this;
    };

}( jQuery ));